import { axios, toCamelCase, toSnakeCase } from '@utils';

const BASE_URL = '/api/v1/legup/seats';

async function fetchScheduleSeats(scheduleId) {
  try {
    const { data } = await axios.get(`${BASE_URL}?schedule_id=${scheduleId}`);
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function createSpot(params) {
  try {
    const { data } = await axios.post(BASE_URL, toSnakeCase(params));
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function editSpot({ params, id }) {
  try {
    const { data } = await axios.put(`${BASE_URL}/${id}`, toSnakeCase(params));
    return toCamelCase(data);
  } catch (error) {
    throw new Error(error);
  }
}

async function removeSeat(id, reason) {
  const response = await axios.delete(`${BASE_URL}/${id}`, { data: { removal_reason: reason } });
  return toCamelCase(response.data);
}

async function publish(id) {
  const response = await axios.put(`${BASE_URL}/${id}/publish`);
  return toCamelCase(response.data);
}

async function unpublish(id) {
  const response = await axios.put(`${BASE_URL}/${id}/unpublish`);
  return toCamelCase(response.data);
}

async function pauseSeat(id) {
  const response = await axios.put(`${BASE_URL}/${id}/pause`);
  return toCamelCase(response.data);
}

async function resumeSeat(id) {
  const response = await axios.put(`${BASE_URL}/${id}/resume`);
  return toCamelCase(response.data);
}

async function fetchSpotHistory(id) {
  const response = await axios.get(`${BASE_URL}/${id}/history`);
  return toCamelCase(response.data);
}

export {
  fetchScheduleSeats,
  createSpot,
  editSpot,
  removeSeat,
  publish,
  unpublish,
  pauseSeat,
  resumeSeat,
  fetchSpotHistory,
};
